<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title> Editar Paciente </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.dni"
                prepend-icon="mdi-account"
                label="D.N.I *"
                dense
                required
                @keypress="onlyNumber"
                @keypress.enter="buscarPacienteDni"
                @blur="buscarPacienteDni"
                :rules="requiredRules"
                maxlength="9"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.numHC"
                prepend-icon="mdi-account"
                label="N° Hist. Clin."
                dense
                maxlength="30"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.apellidos"
                prepend-icon="mdi-account"
                label="Apellidos *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upper"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.nombres"
                prepend-icon="mdi-account"
                label="Nombres *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upperNombres"
                dense
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.fechaNac"
                :value="paciente.fechaNac"
                label="Fecha de Nacimiento"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="sexo"
                v-model="paciente.sexo"
                item-text="paciente.sexo"
                item-value="paciente.sexo"
                label="Sexo"
                dense
                prepend-icon="mdi-account"
              ></v-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.direccion"
                prepend-icon="mdi-map-marker"
                label="Direccion"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.localidad"
                prepend-icon="mdi-map-marker"
                label="Localidad"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
              v-if="
                !this.$store.state.usuario.institucion.notificaWA ||
                this.$store.state.usuario.institucion.idInstitucion === 114 ||
                this.$store.state.usuario.institucion.idInstitucion === 270
              "
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="3"
              v-if="
                this.$store.state.usuario.institucion.notificaWA &&
                this.$store.state.usuario.institucion.idInstitucion !== 114 &&
                this.$store.state.usuario.institucion.idInstitucion !== 270
              "
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="50"
                hint="Ingrese el celular con la característica, sin 0, sin 15 y sin guiones. Ej: 1135036549"
                dense
                :rules="celularRules"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="paciente.telefono"
                prepend-icon="mdi-phone"
                label="Telefono"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="paciente.mail"
                prepend-icon="mdi-email"
                label="E-mail"
                :rules="emailRules"
                dense
                maxlength="80"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="3">
              <v-text-field
                v-model="paciente.telefonoEmergencia"
                prepend-icon="mdi-phone"
                label="Telefono / Contacto Emergencia"
                maxlength="120"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                v-model="paciente.observaciones"
                prepend-icon="mdi-account"
                label="Observaciones del Paciente"
                dense
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="$store.state.usuario.institucion.idInstitucion === 195"
            >
              <v-select
                :items="obrasSociales"
                item-text="nombre"
                item-value="idObraSocial"
                prepend-icon="mdi-account"
                v-model="obraSocial"
                label="Obra Social"
                dense
                no-data-text="No hay Obras Sociales configuradas"
              ></v-select>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              v-if="$store.state.usuario.institucion.idInstitucion === 195"
            >
              <v-text-field
                v-model="nroAfiliado"
                prepend-icon="mdi-account"
                label="Nº de Afiliado"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-row dense>
              <v-col cols="12" sm="4" md="3">
                <v-file-input
                  :rules="rules"
                  accept="image/png, image/jpeg"
                  prepend-icon="mdi-camera"
                  v-model="paciente.foto"
                  show-size
                  chips
                  class="mb-0 pb-0"
                  label="Foto"
                  hint="La imágen debe ser .jpg o .png y pesar 100KB o menos"
                  persistent-hint
                  dense
                  @change="displayPhoto"
                  @click:clear="displayPhoto"
                ></v-file-input>
              </v-col>

              <v-col class="pr-0 mr-0 pt-0 mt-0 ml-0" cols="12" sm="4" md="2">
                <v-badge
                  color="error"
                  overlap
                  offset-y="40"
                  offset-x="40"
                  v-if="src != '' && src != null"
                >
                  <v-icon slot="badge" dark x-small @click="borrarFoto"
                    >mdi-close</v-icon
                  >
                  <v-avatar size="160" tile>
                    <v-img
                      class="pr-0 mr-0 ml-0"
                      max-height="100px"
                      max-width="100px"
                      :aspect-ratio="1"
                      :src="src"
                    >
                    </v-img>
                  </v-avatar>
                </v-badge>
              </v-col>
            </v-row>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="!valid"
            @click.stop="modificarPaciente"
            >Guardar</v-btn
          >

          <v-btn color="error" @click.stop="show = false">Salir</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "../../axios-auth.js";

export default {
  data: (vm) => ({
    horaTurno: null,
    paciente: {
      dni: null,
      apellidos: null,
      nombres: null,
      fechaNac: null,
      sexo: null,
      direccion: null,
      localidad: null,
      mail: null,
      telefono: null,
      telefonoEmergencia: null,
      numHC: "",
      celular: null,
      observaciones: null,
      antecedentes: "",
      antecedentesFamiliares: "",
      foto: null,
      tmpFoto: null,
    },
    tmpFoto: null,
    src: "",
    sexo: ["FEMENINO", "MASCULINO", "OTRO"],
    obrasSociales: [],
    obraSocial: 0,
    nroAfiliado: "",
    valid: false,
    lazy: false,
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    rules: [
      (value) =>
        !value || value.size < 500000 || "La foto debe pesar 500KB o menos",
    ],
    emailRules: [
      (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido",
    ],
    celularRules: [(v) => !v || v.length == 10 || "Debe tener 10 caracteres"],
  }),

  props: ["visible", "idPaciente", "dniActual"],

  computed: {
    show: {
      get() {
        if (this.visible) {
          this.buscarDatosPaciente();
          // Cargar obras sociales si es institución 195
          if (this.$store.state.usuario.institucion.idInstitucion === 195) {
            this.cargarObrasSociales();
          }
        }
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.paciente.dni = "";
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    borrarFoto() {
      this.src = "";
      this.profesional.foto = null;
    },
    buscarDatosPaciente() {
      const idpaciente = this.idPaciente;
      let self = this;

      axios
        .get("/Paciente/BuscarDatosPaciente?", {
          params: {
            idpaciente: idpaciente,
          },
        })
        .then((response) => {
          self.paciente.dni = response.data.nrodocumento;
          self.paciente.apellidos = response.data.apellidos;
          self.paciente.nombres = response.data.nombres;
          if (response.data.fechanacimiento == "0001-01-01T00:00:00")
            self.paciente.fechaNac = "";
          else
            self.paciente.fechaNac = response.data.fechanacimiento.substring(
              0,
              10,
            );
          self.paciente.sexo = response.data.sexo;
          self.paciente.localidad = response.data.localidad;
          self.paciente.direccion = response.data.direccion;
          self.paciente.celular = response.data.celular;
          self.paciente.mail = response.data.email;
          self.paciente.telefono = response.data.telefono;
          self.paciente.telefonoEmergencia = response.data.telefonoEmergencia;
          self.paciente.numHC = response.data.numHC;
          self.paciente.observaciones = response.data.observaciones;
          self.paciente.antecedentes = response.data.antecedentes;
          self.paciente.antecedentesFamiliares =
            response.data.antecedentesFamiliares;
          self.tmpFoto = response.data.foto;
          self.src = response.data.foto;

          // Cargar datos afiliatorios si es institución 195
          if (self.$store.state.usuario.institucion.idInstitucion === 195) {
            self.cargarDatosAfiliatorios();
          }
        })
        .catch((error) => {});
    },
    cargarDatosAfiliatorios() {
      let self = this;
      axios
        .get("/Turnos/BuscarDatosAfiliatoriosPacienteHC", {
          params: {
            idPaciente: self.idPaciente,
          },
        })
        .then((response) => {
          if (response.data != null && response.data != "") {
            self.obraSocial = response.data.idObraSocial;
            self.nroAfiliado = response.data.nroAfiliado;
          }
        })
        .catch((error) => {});
    },
    displayPhoto() {
      this.src = "";
      if (this.paciente.foto != "" && this.paciente.foto != null) {
        const data = URL.createObjectURL(this.paciente.foto);
        this.src = data;
      }
    },
    modificarPaciente() {
      this.$swal({
        title: "Modificar Paciente",
        text: "¿Desea modificar los datos del paciente?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')
          let isValidDate = this.validarFechaNacimiento();
          if (!isValidDate) {
            this.showAlert({
              icon: "error",
              title: "La fecha de nacimiento no tiene un formato válido.",
              vm: this,
              timer: 2000,
            });
          } else {
            var datosPaciente = new FormData();
            datosPaciente.append(
              "idInstitucion",
              this.$store.state.usuario.institucion.idInstitucion,
            );
            datosPaciente.append("nrodocumento", this.paciente.dni);
            datosPaciente.append("apellidos", this.paciente.apellidos);
            datosPaciente.append("nombres", this.paciente.nombres);
            if (this.paciente.fechaNac == null)
              datosPaciente.append("fechaNacimiento", "");
            else
              datosPaciente.append("fechaNacimiento", this.paciente.fechaNac);
            datosPaciente.append("sexo", this.paciente.sexo);
            datosPaciente.append("direccion", this.paciente.direccion);
            datosPaciente.append("localidad", this.paciente.localidad);
            datosPaciente.append("celular", this.paciente.celular.trim());
            datosPaciente.append("telefono", this.paciente.telefono.trim());
            datosPaciente.append(
              "telefonoEmergencia",
              this.paciente.telefonoEmergencia,
            );
            datosPaciente.append("numHC", this.paciente.numHC);
            datosPaciente.append("email", this.paciente.mail.trim());
            datosPaciente.append("observaciones", this.paciente.observaciones);
            datosPaciente.append("antecedentes", this.paciente.antecedentes);
            datosPaciente.append(
              "antecedentesFamiliares",
              this.paciente.antecedentesFamiliares,
            );
            datosPaciente.append("foto", this.paciente.foto);
            datosPaciente.append("idpaciente", this.idPaciente);

            // Agregar datos afiliatorios si es institución 195
            if (this.$store.state.usuario.institucion.idInstitucion === 195) {
              datosPaciente.append("idObraSocial", this.obraSocial || 0);
              datosPaciente.append("nroAfiliado", this.nroAfiliado || "");
            }
            if (
              (this.tmpFoto == null || this.tmpFoto == "") &&
              (this.src == null || this.src == "")
            ) {
              datosPaciente.append("modiFoto", 0);
              datosPaciente.append("ruta", this.tmpFoto);
            }
            if (
              (this.tmpFoto != null || this.tmpFoto != "") &&
              (this.src != null || this.src != "") &&
              this.tmpFoto == this.src
            ) {
              datosPaciente.append("modiFoto", 0);
              datosPaciente.append("ruta", this.tmpFoto);
            }
            if (
              (this.tmpFoto == null || this.tmpFoto == "") &&
              (this.src != null || this.src != "")
            ) {
              datosPaciente.append("modiFoto", 1);
            }
            if (
              (this.tmpFoto != null || this.tmpFoto != "") &&
              (this.src == null || this.src == "")
            ) {
              datosPaciente.append("modiFoto", 1);
              datosPaciente.append("ruta", this.tmpFoto);
            }
            if (
              (this.tmpFoto != null || this.tmpFoto != "") &&
              (this.src != null || this.src != "") &&
              this.tmpFoto != this.src
            ) {
              datosPaciente.append("modiFoto", 1);
            }

            let self = this;
            axios({
              method: "post",
              url: "/Paciente/ModificarPaciente",
              data: datosPaciente,
              header: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
              },
            })
              .then((response) => {
                const pacienteModificado = { ...self.paciente };

                // Agregar datos afiliatorios al objeto emitido
                const obraSocialSeleccionada = self.obrasSociales.find(
                  (os) => os.idObraSocial === self.obraSocial,
                );
                pacienteModificado.obraSocialNombre = obraSocialSeleccionada
                  ? obraSocialSeleccionada.nombre
                  : "";
                pacienteModificado.nroAfiliado = self.nroAfiliado;

                self.$refs.form.resetValidation();
                self.vaciarModels();
                self.paciente.dni = "";
                document.getElementsByClassName(
                  "v-dialog--active",
                )[0].scrollTop = 0;
                self.showAlert({
                  icon: "success",
                  title: "Paciente modificado exitosamente",
                  vm: self,
                  timer: 2000,
                });
                self.$emit("pacienteModificado", pacienteModificado);
              })
              .catch((error) => {
                self.showAlert({
                  icon: "error",
                  title:
                    "El paciente no pudo ser modificado. Probablemente eligió un nuevo número de dni que ya esté siendo utilizado por otro paciente o el formato de foto no es correcto.",
                  vm: this,
                  timer: 2000,
                });
              });
          }
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    validarFechaNacimiento() {
      if (this.paciente.fechaNac.toString().length > 10) return false;
      else return true;
    },

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    upper() {
      if (this.paciente.apellidos != null)
        this.paciente.apellidos = this.paciente.apellidos
          .toString()
          .toUpperCase();
    },
    upperNombres() {
      if (this.paciente.nombres != null)
        this.paciente.nombres = this.paciente.nombres.toString().toUpperCase();
    },

    vaciarModels() {
      this.paciente.apellidos = "";
      this.paciente.nombres = "";
      this.paciente.direccion = "";
      this.paciente.localidad = "";
      this.paciente.celular = "";
      this.paciente.telefono = "";
      this.paciente.telefonoEmergencia = "";
      this.paciente.numHC = "";
      this.paciente.mail = "";
      this.paciente.observaciones = "";
      this.paciente.antecedentes = "";
      this.paciente.antecedentesFamiliares = "";
      this.paciente.fechaNac = null;
      this.paciente.sexo = null;
      this.paciente.foto = null;
      this.obraSocial = 0;
      this.nroAfiliado = "";
    },
    cargarObrasSociales() {
      let self = this;
      axios
        .get("/ObraSocial/GetObraSocialActivasDeInst", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        })
        .then((response) => {
          self.obrasSociales = response.data;
        })
        .catch((error) => {});
    },

    showAlert(alertInfo) {
      alertInfo.vm.$swal.fire({
        icon: alertInfo.icon,
        title: alertInfo.title,
        showConfirmButton: false,
        background: "#ececec",
        timer: alertInfo.timer,
      });
    },
    buscarPacienteDni() {
      if (isNaN(this.paciente.dni)) {
        this.showAlert({
          timer: 3200,
          icon: "error",
          title: "El D.N.I. debe estar compuesto sólo por números.",
          vm: this,
        });
        this.paciente.dni = "";
        this.paciente.idPaciente = 0;
        return;
      }
      if (this.paciente.dni != "" && this.paciente.dni != null)
        this.paciente.dni = parseInt(this.paciente.dni);

      const pacientesData = {
        dni: this.paciente.dni,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Paciente/GetPacienteDni?", {
          params: {
            dni: pacientesData.dni,
            idInstitucion: pacientesData.idInstitucion,
          },
        })
        .then(function (response) {
          if (
            response.data != null &&
            response.data != "" &&
            response.data.idpaciente != self.idPaciente
          ) {
            self.showAlert({
              icon: "error",
              title:
                "DNI registrado para el paciente: " +
                response.data.apellidos +
                ", " +
                response.data.nombres,
              vm: self,
              timer: 3500,
            });

            self.paciente.dni = self.dniActual;
          }
        })
        .catch(function (error) {});
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  created() {
    this.vaciarModels();
  },
};
</script>
